import React, { useState, useEffect } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import processTemplateService from '../services/processTemplateService';

const DIAMETER_OPTIONS = [
  2.5, 3.0, 3.5, 4.0, 4.5, 5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 8.0,
  9.525, 10.0, 12.0, 12.7, 14.0, 16.0, 18.0, 19.0, 20.0
];

export function ProcessTemplateSelector({ value, onChange, initialData = null }) {
  const [category, setCategory] = useState('');
  const [diameter, setDiameter] = useState('');
  const [totalLength, setTotalLength] = useState('');
  const [edgeLength, setEdgeLength] = useState('');
  const [matchedTemplates, setMatchedTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Parse initial data if provided
  useEffect(() => {
    if (initialData?.name) {
      const parts = initialData.name.split('-');
      if (parts.length >= 2) {
        setCategory(parts[0] === '钻头' ? 'drill' : 'countersink');
        const diaMatch = parts[1].match(/([\d.]+)mm/);
        if (diaMatch) setDiameter(diaMatch[1]);
        
        if (parts.length >= 4) {
          const lenMatch = parts[2].match(/总长(\d+)mm/);
          if (lenMatch) setTotalLength(lenMatch[1]);
          
          const edgeMatch = parts[3].match(/刃长(\d+)/);
          if (edgeMatch) setEdgeLength(edgeMatch[1]);
        }
      }
    }
  }, [initialData]);
  
// Query matching templates when parameters change
useEffect(() => {
if (category && diameter && edgeLength) {
fetchMatchedTemplates();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [category, diameter, totalLength, edgeLength]);
  
  const fetchMatchedTemplates = async () => {
    setLoading(true);
    try {
      const params = { 
        tool_category: category,
        diameter: parseFloat(diameter),
        edge_length: parseInt(edgeLength),
      };
      
      if (category === 'drill' && totalLength) {
        params.total_length = parseInt(totalLength);
      }
      
      const response = await processTemplateService.matchForCost(params);
      if (response.success) {
        setMatchedTemplates([response.template]);
        if (response.template && !value) {
          onChange(response.template._id);
        }
      }
    } catch (error) {
      console.error('Failed to match templates:', error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-4 gap-2">
        {/* Category Select */}
        <Select value={category} onValueChange={setCategory}>
          <SelectTrigger>
            <SelectValue placeholder="类别" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="drill">钻头/扩铰刀</SelectItem>
            <SelectItem value="countersink">锪窝钻</SelectItem>
          </SelectContent>
        </Select>
        
        {/* Diameter Select */}
        <Select value={diameter} onValueChange={setDiameter}>
          <SelectTrigger>
            <SelectValue placeholder="直径" />
          </SelectTrigger>
          <SelectContent>
            {DIAMETER_OPTIONS.map(d => (
              <SelectItem key={d} value={String(d)}>
                {d}mm
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        
        {/* Total Length Select (only for drill) */}
        {category === 'drill' && (
          <Select value={totalLength} onValueChange={setTotalLength}>
            <SelectTrigger>
              <SelectValue placeholder="总长档" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="95">总长95mm</SelectItem>
              <SelectItem value="150">总长150mm</SelectItem>
            </SelectContent>
          </Select>
        )}
        
        {/* Edge Length Select */}
        <Select value={edgeLength} onValueChange={setEdgeLength}>
          <SelectTrigger>
            <SelectValue placeholder="刃长档" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="50">刃长50mm</SelectItem>
            <SelectItem value="80">刃长80mm</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      {/* Matched Results */}
      {matchedTemplates.length > 0 && (
        <div className="border rounded p-3 bg-gray-50">
          <p className="text-sm font-medium">匹配到的工序模版:</p>
          {matchedTemplates.map(t => (
            <div key={t._id} className="mt-2">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  name="template"
                  value={t._id}
                  checked={value === t._id}
                  onChange={() => onChange(t._id)}
                />
                <span className="text-sm">
                  {t.name} 
                  ({t.steps[0]?.standard_time}分钟 / {t.steps[1]?.standard_time}分钟)
                </span>
              </label>
            </div>
          ))}
        </div>
      )}
      
      {loading && <p className="text-sm text-gray-500">匹配中...</p>}
    </div>
  );
}

export default ProcessTemplateSelector;
